import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../../../contexts/AuthContext';
import { API } from '../../../../lib/api';
import { formatErr } from '../../../../components/admin/billing/shared';

const FILTERS = [['', 'All'], ['new', 'New'], ['in_progress', 'In progress'], ['live', 'Live']];
const daysLeft = (d) => (d ? Math.ceil((new Date(`${d}T00:00:00`) - new Date().setHours(0, 0, 0, 0)) / 86400000) : null);
const PILL = { new: 'bg-sky-100 text-sky-800', in_progress: 'bg-amber-100 text-amber-800', live: 'bg-emerald-100 text-emerald-800' };

export default function MigrationsDesk() {
  const { authHeader } = useAuth();
  const [status, setStatus] = useState('');
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let live = true;
    axios.get(`${API}/platform/migrations`, { headers: authHeader(), params: status ? { status } : {} })
      .then((r) => live && setRows(r.data)).catch((e) => { if (live) { setRows([]); toast.error(formatErr(e)); } });
    return () => { live = false; };
  }, [authHeader, status]);

  return (
    <div className="space-y-4 p-4 sm:p-6" data-testid="mig-desk">
      <div><h1 className="text-2xl font-semibold text-slate-900">Migrations</h1>
        <p className="text-sm text-slate-500">Switch-to-Driveline requests. Import their data, keep the tracker updated, take them live.</p></div>
      <div className="flex gap-1.5">{FILTERS.map(([k, l]) => (
        <button key={k} type="button" onClick={() => setStatus(k)} className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${status === k ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-300 text-slate-600'}`} data-testid={`mig-filter-${k || 'all'}`}>{l}</button>))}</div>
      {rows === null ? <Loader2 className="animate-spin" /> : (
        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="mig-list">
          {rows.length === 0 && <p className="p-6 text-center text-sm text-slate-500" data-testid="mig-empty">No requests here yet.</p>}
          {rows.map((r) => {
            const left = daysLeft(r.go_live_date);
            return (
              <Link key={r.id} to={`/admin/platform/migrations/${r.id}`} className="flex flex-wrap items-center gap-3 border-b border-slate-100 px-4 py-3 text-sm hover:bg-slate-50" data-testid={`mig-row-${r.id}`}>
                <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${PILL[r.status]}`}>{r.status.replace('_', ' ')}</span>
                <span className="min-w-0 flex-1"><b className="text-slate-900">{r.workshop_name}</b> <span className="text-slate-500">· {r.owner_name} · {r.city || '—'} · {r.file_count} file(s)</span></span>
                <span className="text-xs text-slate-600">{r.go_live_date ? `Go-live ${r.go_live_date}${left !== null && r.status !== 'live' ? ` · ${left >= 0 ? `${left} days left` : `${-left} days late`}` : ''}` : 'Go-live not set'}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
